export default __webpack_public_path__ + "static/blob2-bd87b6004e962013a549bd226f1ada93.svg";